import {IHttpInterceptor, ILogService, IPromise, IQService, IRootScopeService} from "angular";
import {includes} from "lodash";

const IGNORED_ERROR_STATUSES = [401, 403, 405];

export class HttpErrorHandlingInterceptor implements IHttpInterceptor {
    /* @ngInject */
    public static factory($q: IQService,
                          $log: ILogService,
                          $rootScope: IRootScopeService): HttpErrorHandlingInterceptor {
        return new HttpErrorHandlingInterceptor($q, $log, $rootScope);
    }

    /* @ngInject */
    constructor(private $q: IQService,
                private $log: ILogService,
                private $rootScope: IRootScopeService) {
    }

    public responseError = (responseFailure): IPromise<any> => {
        if (!includes(IGNORED_ERROR_STATUSES, responseFailure.status)) {
            this.$log.error("Unhandled HTTP error: ", responseFailure);
            this.$rootScope.$broadcast("http-error", responseFailure);
        }
        return this.$q.reject(responseFailure);
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/shared/config/http-error-handling-interceptor.service.ts